import { gql } from "@apollo/client"

export const GET_ORGANIZATIONS = gql`
  query Organizations($staff_id: ID!, $organization_id: ID!) {
    organizations: statsOrganizationsByUid(staff_id: $staff_id, organization_id: $organization_id) {
      organization_id
      organization_name
      organization_status
      current_staff_users
      current_participants
      current_programs
      current_locations
      organization_id_stamp
    }
  }
`

export const CHANGE_STATUS_ORGANIZATION = gql`
  mutation ChangeStatusOrganization(
    $staff_id: String!
    $organization_id: String!
    $organization_status: String!
  ) {
    changeOrganizationStatus(
      staff_id: $staff_id
      organization_id: $organization_id
      organization_status: $organization_status
    ) {
      organization_id
    }
  }
`

// export const GET_ORGANIZATION = gql`
//   query Organization($staff_id: ID!, $organization_id: ID!) {
//     organization(staff_id: $staff_id,  organization_id: $organization_id) {
//       organization_id
//       organization_alias
//       organization_name
//       organization_country
//       organization_address
//       organization_city
//       organization_state
//       organization_zip_code
//       organization_website
//       organization_email_address
//       organization_phone_number
//       organization_phone_telerecovery
//       organization_fein
//       site_id
//       contract_number
//       subcontract_number
//       organization_type
//       enterprise_id
//       microservices
//       organization_admins {
//         staff_id
//         staff_alias
//         staff_name_first
//         staff_name_last
//         staff_email_address
//       }
//     }
//   }
// `

// export const ADD_ORGANIZATION = gql`
//   mutation AddOrganization(
//     $staff_id: String!
//     $staff_alias: String
//     $organization_name: String!
//     $staff_name_first: String!
// 		$staff_name_last: String!
// 		$staff_email_address: String!
//     $staff_account_password: String!
// 		$organization_country: String
// 		$organization_address: String
// 		$organization_city: String
// 		$organization_state: String
// 		$organization_zip_code: String
// 		$organization_website: String
// 		$organization_email_address: String
// 		$organization_phone_number: String
//     $organization_phone_telerecovery: String
//     $organization_fein: String
//     $site_id: String
//     $contract_number: String
//     $subcontract_number: String
//     $organization_type: String
//     $enterprise_id: String
//     $microservices: [String]
//     $admin_staff_organization_alias:  String!
// 		$admin_staff_organization_id: String!
// 		$admin_staff_enterprise_id: String!
// 		$admin_staff_enterprise_alias: String!
//   ) {
//     addOrganization(
//       staff_id: $staff_id
//       organization_name: $organization_name
//       organization_country: $organization_country
//       organization_address: $organization_address
//       organization_city: $organization_city
//       organization_state: $organization_state
//       organization_zip_code: $organization_zip_code
//       organization_website: $organization_website
//       organization_email_address: $organization_email_address
//       organization_phone_number: $organization_phone_number
//       organization_phone_telerecovery: $organization_phone_telerecovery
//       organization_fein: $organization_fein
//       site_id: $site_id
//       contract_number: $contract_number
//       subcontract_number: $subcontract_number
//       organization_type: $organization_type
//       staff_name_first: $staff_name_first
//       staff_name_last: $staff_name_last
//       staff_email_address: $staff_email_address
//       staff_account_password: $staff_account_password
//       enterprise_id: $enterprise_id
//       microservices: $microservices
//       staff_alias: $staff_alias
//       admin_staff_organization_alias: $admin_staff_organization_alias
//       admin_staff_organization_id: $admin_staff_organization_id
//       admin_staff_enterprise_id: $admin_staff_enterprise_id
//       admin_staff_enterprise_alias: $admin_staff_enterprise_alias
//     ) {
//       organization_id
//     }
//   }
// `

// export const EDIT_ORGANIZATION = gql`
//   mutation EditOrganization(
//     $staff_id: String!
//     $organization_id: String!
//     $organization_name: String!
// 		$organization_country: String
// 		$organization_address: String
// 		$organization_city: String
// 		$organization_state: String
// 		$organization_zip_code: String
// 		$organization_website: String
// 		$organization_email_address: String
// 		$organization_phone_number: String
//     $organization_phone_telerecovery: String
//     $organization_fein: String
//     $site_id: String
//     $contract_number: String
//     $subcontract_number: String
//     $microservices: [String]
//   ) {
//     editOrganization(
//       staff_id: $staff_id
//       organization_id: $organization_id
//       organization_name: $organization_name
//       organization_country: $organization_country
//       organization_address: $organization_address
//       organization_city: $organization_city
//       organization_state: $organization_state
//       organization_zip_code: $organization_zip_code
//       organization_website: $organization_website
//       organization_email_address: $organization_email_address
//       organization_phone_number: $organization_phone_number
//       organization_phone_telerecovery: $organization_phone_telerecovery
//       organization_fein: $organization_fein
//       site_id: $site_id
//       contract_number: $contract_number
//       subcontract_number: $subcontract_number
//       microservices: $microservices
//     ) {
//       organization_id
//     }
//   }
// `
// export const GET_ENTERPRISE = gql`
//   query Enterprise($staff_id: ID!, $enterprise_id: ID!) {
//     enterprise(staff_id: $staff_id, enterprise_id: $enterprise_id) {
//       enterprise_id
//       enterprise_alias
//       enterprise_name
//       enterprise_country
//       enterprise_address
//       enterprise_city
//       enterprise_state
//       enterprise_zip_code
//       enterprise_website
//       enterprise_email_address
//       enterprise_phone_number
//       microservices
//       enterprise_admins {
//         staff_id
//         staff_alias
//         staff_name_first
//         staff_name_last
//         staff_email_address
//       }
//     }
//   }
// `



// export const LOAD_EDIT_FORM = gql`
// query LoadForm($staff_id: ID!, $enterprise_id: ID!) {
//   enterprise(staff_id: $staff_id, enterprise_id: $enterprise_id) {
//     enterprise_id
//     enterprise_alias
//     enterprise_name
//     enterprise_country
//     enterprise_address
//     enterprise_city
//     enterprise_state
//     enterprise_zip_code
//     enterprise_website
//     enterprise_email_address
//     enterprise_phone_number
//     microservices
//     enterprise_admins {
//       staff_id
//       staff_alias
//       staff_name_first
//       staff_name_last
//       staff_email_address
//     }
//   }
// }
// `

// export const LOAD_ADD_ORGANIZATION_FORM = gql`
// query LoadForm($staff_id: ID!, $enterprise_id: ID!) {
//   enterprises:enterprisesByUid(staff_id: $staff_id, enterprise_id: $enterprise_id) {
//     enterprise_id
//     enterprise_name
//     microservices
//   }
// }
// `